import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";

@Component({
  selector: "app-video-controls",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./video-controls.component.html",
  styleUrl: "./video-controls.component.scss",
})
export class VideoControlsComponent {
  @Input() isMuted = false;
  @Input() isCameraOff = false;
  @Input() isConnected = false;

  @Output() toggleMute = new EventEmitter<void>();
  @Output() toggleCamera = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();
  @Output() end = new EventEmitter<void>();
}
